import { fetchMainApi } from '@/api/index';
export const getDocuments = async () => {
  return fetchMainApi('GET', '/account-documents');
};

export const uploadDocuments = async (files) => {
  const formData = new FormData();
  files.forEach((uploadableFile, index) => {
    // uploadableFile has structure: { file: File, id: string, url: string, status: string }
    // Backend expects 'files[]' as the field name
    formData.append('files[]', uploadableFile.file);
  });

  return fetchMainApi(
    'POST',
    '/account-documents',
    { body: formData },
    'multipart/form-data'
  );
};

export const deleteDocument = async (id) => {
  return fetchMainApi('DELETE', `/account-documents/${id}`);
};

export const updateDocument = async (formData) => {
  return fetchMainApi(
    'PATCH',
    '/account-documents',
    { body: formData },
    'multipart/form-data'
  );
};

export const downloadDocument = async (id) => {
  // For file downloads, we need to use fetch directly to handle blobs
  const token = localStorage.getItem('token') || '';
  const apiHost = process.env.VUE_APP_API_HOST;
  const baseUrl = apiHost ? `${apiHost}/api` : '/api';

  const response = await fetch(`${baseUrl}/account-documents/${id}/download`, {
    method: 'GET',
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      Accept: 'application/json, application/octet-stream',
    },
    credentials: 'include'
  });
  
  if (!response.ok) {
    throw new Error(`Download failed: ${response.status}`);
  }
  
  const blob = await response.blob();
  const contentDisposition = response.headers.get('content-disposition');
  
  let originalName = 'file';
  if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(contentDisposition);
    if (matches != null && matches[1]) {
      originalName = matches[1].replace(/['"]/g, "");
    }
  }
  
  return {
    file: blob,
    originalName
  };
};